import type { Tela } from "../Aplicacao"
import * as Icones from "../componentes/Icones"
import { DADOS_DO_ITEM, type GrupoDeConfiguracao, type ItemDeConfiguracao } from "../itens-de-configuracao"
import type { ChaveDeTela } from "../registro-de-telas"
import type { AbaDoPerfil } from "../telas/Perfil"
import type { SecaoDoTrilho } from "./Casca"

/* AS TELAS DA BUSCA DA CASCA (spec 0130), em funções puras: o que a busca
   oferece sai do mesmo menu que a conta vê (as seções do trilho e os grupos
   de Configurações do alcance), para não oferecer o que o menu esconde. */

export type DestinoDaBusca = {
  chave: string
  titulo: string
  detalhe: string
  icone: Icones.Icone
  abrir: () => void
}

export type AcoesDosDestinos = {
  irPara: (chave: ChaveDeTela) => void
  abrirConfiguracao: (item: ItemDeConfiguracao) => void
  abrirPerfil: (aba: AbaDoPerfil) => void
}

const ABAS_DO_PERFIL_NA_BUSCA: { aba: AbaDoPerfil; titulo: string; icone: Icones.Icone }[] = [
  { aba: "dados", titulo: "Meus dados", icone: Icones.Pessoa },
  { aba: "designacoes", titulo: "Designações", icone: Icones.Fiscalizacao },
  { aba: "seguranca", titulo: "Segurança", icone: Icones.Chave },
  { aba: "atividade", titulo: "Atividade", icone: Icones.Historico },
  { aba: "preferencias", titulo: "Preferências", icone: Icones.Configuracao },
]

const MAXIMO_DE_TELAS = 6
export const TAMANHO_MINIMO = 2

export function normalizar(texto: string): string {
  return texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()
}

export function destinosDaBusca(
  secoes: SecaoDoTrilho<ChaveDeTela>[],
  grupos: GrupoDeConfiguracao[] | null,
  acoes: AcoesDosDestinos,
): DestinoDaBusca[] {
  const destinos: DestinoDaBusca[] = []
  for (const secao of secoes) {
    for (const item of secao.itens) {
      if (item.emBreve === true) continue
      destinos.push({ chave: item.chave, titulo: item.rotulo, detalhe: secao.titulo, icone: item.icone, abrir: () => acoes.irPara(item.chave) })
    }
  }
  for (const grupo of grupos ?? []) {
    for (const item of grupo.itens) {
      destinos.push({
        chave: `configuracoes/${item}`,
        titulo: DADOS_DO_ITEM[item].rotulo,
        detalhe: `Configurações › ${grupo.rotulo}`,
        icone: DADOS_DO_ITEM[item].icone,
        abrir: () => acoes.abrirConfiguracao(item),
      })
    }
  }
  for (const { aba, titulo, icone } of ABAS_DO_PERFIL_NA_BUSCA) {
    destinos.push({ chave: `perfil/${aba}`, titulo, detalhe: "Meu perfil", icone, abrir: () => acoes.abrirPerfil(aba) })
  }
  return destinos
}

export function filtrarDestinos(destinos: DestinoDaBusca[], termo: string): DestinoDaBusca[] {
  const procurado = normalizar(termo.trim())
  if (procurado.length < TAMANHO_MINIMO) return []
  return destinos.filter((d) => normalizar(`${d.titulo} ${d.detalhe}`).includes(procurado)).slice(0, MAXIMO_DE_TELAS)
}

/** A tela aberta como destino da busca, para contar as visitas; a ficha e o processo não contam. */
export function chaveDoDestino(tela: Tela): string | null {
  if (tela.nome === "ficha" || tela.nome === "esteira") return null
  if (tela.nome === "configuracoes") return "item" in tela && tela.item !== undefined ? `configuracoes/${tela.item}` : "configuracoes"
  if (tela.nome === "perfil") return `perfil/${"aba" in tela && tela.aba !== undefined ? tela.aba : "dados"}`
  return tela.nome
}
